import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LEGAL_LINKS } from "../config/legalLinks";

export default function LegalPolicyRedirect({ policy }) {
  const { t } = useTranslation();
  const url = LEGAL_LINKS[policy];
  useEffect(() => { window.location.replace(url); }, [url]);
  return <main style={{ maxWidth: 720, margin: "3rem auto", padding: "2rem" }}>
    <h1>{t(policy === "privacy" ? "auth.privacy" : "auth.terms")}</h1>
    <p><a href={url}>{t("auth.openPolicy")}</a></p>
  </main>;
}
